var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref, watch } from "vue";
import { getSelectableObjectStores } from "@/api/objectStores";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DescribeObjectStore from "@/components/ObjectStore/DescribeObjectStore.vue";
import ObjectStoreBadges from "@/components/ObjectStore/ObjectStoreBadges.vue";
import ProvidedQuotaSourceUsageBar from "@/components/User/DiskUsage/Quota/ProvidedQuotaSourceUsageBar.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectObjectStore',
    props: {
        selectedObjectStoreId: { default: null },
        defaultOptionTitle: null,
        defaultOptionDescription: null,
        forWhat: null,
        parentError: { default: null }
    },
    emits: ["onSubmit"],
    setup(__props, { emit }) {
        const props = __props;
        const loading = ref(true);
        const error = ref(props.parentError);
        const popoverProps = {
            placement: "rightbottom",
            boundary: "window", // don't warp the popover to squeeze it into this modal
        };
        const objectStores = ref([]);
        const loadingObjectStoreInfoMessage = ref("Loading object store information");
        const whyIsSelectionPreferredText = ref(`
Selecting this will reset Galaxy to default behaviors configured by your Galaxy administrator.
Select a preferred object store for new datasets. This is should be thought of as a preferred
object store because depending the job and workflow configuration execution configuration of
this Galaxy instance - a different object store may be selected. After a dataset is created,
click on the info icon in the history panel to view information about where it is stored. If it
is not stored in the correct place, contact your Galaxy administrator for more information.
`);
        watch(() => props.parentError, () => {
            error.value = props.parentError;
        });
        function handleError(e) {
            const errorMessage = errorMessageAsString(e);
            error.value = errorMessage;
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield getSelectableObjectStores();
                objectStores.value = data;
                loading.value = false;
            }
            catch (e) {
                handleError(e);
            }
        }));
        function variant(objectStoreId) {
            if (props.selectedObjectStoreId == objectStoreId) {
                return "outline-primary";
            }
            else {
                return "outline-info";
            }
        }
        function handleSubmit(preferredObjectStoreId) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onSubmit", preferredObjectStoreId);
            });
        }
        return { __sfc: true, props, loading, error, popoverProps, objectStores, loadingObjectStoreInfoMessage, whyIsSelectionPreferredText, handleError, variant, emit, handleSubmit, LoadingSpan, DescribeObjectStore, ObjectStoreBadges, ProvidedQuotaSourceUsageBar };
    }
});
